import PropTypes from 'prop-types';

export const poLocationListItem = PropTypes.shape({
  ownerId: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  startingPONumber: PropTypes.number,
  billingAddressId: PropTypes.string.isRequired,
});

export const poLocationList = PropTypes.arrayOf(poLocationListItem);

export const poLocationAddress = PropTypes.shape({
  id: PropTypes.string.isRequired,
  street: PropTypes.string,
  street2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
});

export const poLocationAddressList = PropTypes.arrayOf(poLocationAddress);
